import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/categoriaProducto/importer/categoriaProductoImporterActions';

export default importerReducers(actions);
